
import {Component, input} from '@angular/core';
import {RouterModule} from '@angular/router';

@Component({
  selector: 'app-logo',
  imports: [RouterModule],
  template: `<a routerLink="/my-orders">
    <img
      [src]="type() === 'w' ? 'assets/icons/logo-white.svg' : 'assets/icons/logo-white.svg'"
      alt="Genetics Logo"
      [width]="width()"
  /></a>`,
})
export class LogoComponent {
  readonly width = input('');
  readonly type = input('');
}
